import React from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

const CustomButton = ({ id, text, Icon, active, link }) => {
  return (
    <div className="m-1" id={id}>
      <button
        className={`border-[1px] w-full mb-8 sm:mb-7 p-3 sm:p-3 sm:mt-0 sm:h-[30px] sm:ml-0 border-black flex row items-center sm:w-full rounded-[25px]
           ${active === text ? "bg-red-600 text-white dark:bg-red-600" : "dark:bg-white dark:text-black"}
           `}
      >
        <Icon size={17} />
        <div className="flex row justify-between relative ml-2 w-full items-center">
          <h3 className="text-center text-[10px] sm:text-[15px] font-bold font-sans mr-2">
            {text}
          </h3>
          <MdOutlineKeyboardArrowRight
            size={17}
            className=""
          />
        </div>
      </button>
    </div>
  );
};

export default CustomButton;
